import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-8 px-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-600 text-xl">
              <li>
                <a href="#" className="hover:text-blue-600">
                  Home
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600">
                  Services
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600">
                  Industries
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600">
                  Products
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600">
                  Case Studies
                </a>
              </li>
            </ul>
          </div>

          {/* Second Quick Links */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-600 text-xl">
              <li>
                <a href="#"  >
                  Career
                </a>
              </li>
              <li>
                <a href="#">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" >
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-600 text-xl">
              <li>Sales: +91 86199 48778</li>
              <li>Sales: +91 96638 70199</li>
              <li>HR: +91 97830 47112</li>
              <li>
                <a
                  href="mailto:info@crmlanding.in"
                >
                  info@crmlanding.in
                </a>
              </li>
              <li>
                <a
                  href="mailto:sales@crmlanding.in"
                >
                  sales@crmlanding.in
                </a>
              </li>
            </ul>
          </div>

          {/* Offices */}
          <div>
            <h3 className="text-2xl font-semibold mb-4">Offices</h3>
            <ul className="space-y-4 text-gray-600 text-xl">
              <li>
                <div className="flex items-start gap-2">
                  <img
                    className="mr-2 mt-2 w-[72px] "
                    src={require("../assets/img/ind.png")}
                    alt="Ind"
                  />
                  <div className="text-md">
                    1st & 2nd Floor, Shyama Royale,
                    Shastri Nagar, Ajmer - Rajasthan
                    (305001) - INDIA
                  </div>
                </div>
              </li>
              <li>
                <div className="flex gap-2">
                  <img
                    className="mr-2 w-[72px] "
                    src={require("../assets/img/usa.png")}
                    alt="Ind"
                  />
                  <div className="text-md">
                    8034 Westgate Lane
                    <br />
                    Severn, MD, 21144, USA
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className=" flex lg:flex-row flex-col mt-8 border-t-2 border-t-[#0D4282] pt-4 mt-20 text-gray-600 justify-between">
          {/* Logo */}
          <div className="logo">
            <Link to="/">
              <img src={require('../assets/img/crmLogo.png')} alt="CRM Landing" className="h-12" />
            </Link>
          </div>
          <p className="text-center m-4 lg:text-xl text-lg ">
            Copyright © CRM Landing Software Private Limited. All Rights
            Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
